"use strict";

exports.__esModule = true;
exports.StreamData = exports.Parser = exports.CreativeData = exports.AdvertData = void 0;
var _sax = _interopRequireDefault(require("sax"));
var _YoLog = require("../Utils/YoLog");
var _ConversionUtils = require("../Utils/ConversionUtils");
var _AdBreak = require("../Core/AdBreak");
var _Advert = require("../Core/Advert");
var _AdvertWrapper = require("../Core/AdvertWrapper");
var _CompanionCreative = require("../Core/CompanionCreative");
var _IconClickFallbackImage = require("../Core/IconClickFallbackImage");
var _IndustryIcon = require("../Core/IndustryIcon");
var _InteractiveCreative = require("../Core/InteractiveCreative");
var _LinearCreative = require("../Core/LinearCreative");
var _NonLinearAds = require("../Core/NonLinearAds");
var _NonLinearCreative = require("../Core/NonLinearCreative");
var _Resource = require("../Core/Resource");
var _VASTProperty = require("../Core/VASTProperty");
var _VideoClicks = require("../Core/VideoClicks");
var _XmlNode = require("../Core/XmlNode");
var _TrackingReport = require("../Core/TrackingReport");
var _AdVerification = require("../Core/AdVerification");
var _CompanionAds = require("../Core/CompanionAds");
var _StringUtils = require("../Utils/StringUtils");
var _HttpUtils = require("../Utils/HttpUtils");
var _AnalyticPayload = require("./AnalyticPayload");
var _CollectionUtils = require("../Utils/CollectionUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var CreativeType = {
  NONE: 0,
  COMPANION: 1,
  LINEAR: 2,
  NONLINEAR: 3
};
var AD_TITLE_TOKEN = "AdTitle";
var AD_TOKEN = "Ad";
var AD_SERVING_ID_TOKEN = "AdServingId";
var ALT_TEXT_TOKEN = "AltText";
var CLICK_THROUGH_TOKEN = "ClickThrough";
var CLICK_TRACKING_TOKEN = "ClickTracking";
var COMPANION_CLICK_THROUGH_TOKEN = "CompanionClickThrough";
var COMPANION_CLICK_TRACKING_TOKEN = "CompanionClickTracking";
var CUSTOM_CLICK = "CustomClick";
var DESCRIPTION_TOKEN = "Description";
var DURATION_TOKEN = "Duration";
var ERROR_TOKEN = "Error";
var ICON_CLICK_THROUGH_TOKEN = "IconClickThrough";
var ICON_CLICK_TRACKING_TOKEN = "IconClickTracking";
var ICON_VIEW_TRACKING_TOKEN = "IconViewTracking";
var IFRAME_RESOURCE_TOKEN = "IFrameResource";
var NON_LINEAR_CLICK_THROUGH_TOKEN = "NonLinearClickThrough";
var NON_LINEAR_CLICK_TRACKING_TOKEN = "NonLinearClickTracking";
var NOT_VIEWABLE_TOKEN = "NotViewable";
var VERIFICATION_PARAMETERS_TOKEN = "VerificationParameters";
var VIEWABLE_TOKEN = "Viewable";
var VIEW_UNDETERMINED_TOKEN = "ViewUndetermined";
var VMAP_ADBREAK_TOKEN = "vmap:AdBreak";
var VMAP_TOKEN = "vmap:VMAP";
var YOSPACE_ADBREAK_TOKEN = "yospace:AdBreak";
var YOSPACE_STREAM_TOKEN = "yospace:Stream";
var VMAP_TRACKING_TOKEN = "vmap:Tracking";
var VAST_TOKEN = "VAST";
var AD_WRAPPER_TOKEN = "AdWrapper";
var CATEGORY_TOKEN = "Category";
var AD_SYSTEM_TOKEN = "AdSystem";
var ADVERTISER_TOKEN = "Advertiser";
var SURVEY_TOKEN = "Survey";
var PRICING_TOKEN = "Pricing";
var UNIVERSAL_AD_ID_TOKEN = "UniversalAdId";
var EXTENSIONS_TOKEN = "Extensions";
var CREATIVE_TOKEN = "Creative";
var LINEAR_TOKEN = "Linear";
var ICON_TOKEN = "Icon";
var ICON_CLICK_FALLBACK_IMAGE_TOKEN = "IconClickFallbackImage";
var IMPRESSION_TOKEN = "Impression";
var AD_PARAMETERS_TOKEN = "AdParameters";
var MEDIAFILE_TOKEN = "MediaFile";
var INTERACTIVE_CREATIVE_FILE_TOKEN = "InteractiveCreativeFile";
var NON_LINEAR_ADS_TOKEN = "NonLinearAds";
var NON_LINEAR_TOKEN = "NonLinear";
var COMPANION_ADS_TOKEN = "CompanionAds";
var COMPANION_TOKEN = "Companion";
var STATIC_RESOURCE_TOKEN = "StaticResource";
var HTML_RESOURCE_TOKEN = "HTMLResource";
var TRACKING_TOKEN = "Tracking";
var VERIFICATION_TOKEN = "Verification";
var JAVASCRIPT_RESOURCE_TOKEN = "JavaScriptResource";
var EXECUTABLE_RESOURCE_TOKEN = "ExecutableResource";
var EXTENSION_TOKEN = "Extension";
var CREATIVE_EXTENSIONS_TOKEN = "CreativeExtensions";
var CREATIVE_EXTENSION_TOKEN = "CreativeExtension";
var VMAP_ADTAG_URI = "vmap:AdTagURI";
var MIN_VAST_VERSION = 4.2;
var YOPSI_PATTERN = "yo.p.si=([^&]+)";
function logParsingSummary(parser) {
  if (_YoLog.YoLog.debugflags & _YoLog.DebugFlags.DEBUG_PARSING) {
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "\n--------------- VMAP PARSING SUMMARY ---------------");
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, " * Number of ad breaks: " + parser.linearAdBreaks.length);
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, " * Number of nonlinear ad breaks: " + parser.nonLinearAdBreaks.length);
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, " * Number of display ad breaks: " + parser.displayAdBreaks.length);
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, " * Stream duration: " + parser.streamData.duration + "ms\n");
    for (var _iterator = _createForOfIteratorHelperLoose(parser.linearAdBreaks), _step; !(_step = _iterator()).done;) {
      var ab = _step.value;
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, ab.toString());
      for (var _iterator4 = _createForOfIteratorHelperLoose(ab.getAdverts()), _step4; !(_step4 = _iterator4()).done;) {
        var ad = _step4.value;
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, ad.toString());
      }
    }
    for (var _iterator2 = _createForOfIteratorHelperLoose(parser.nonLinearAdBreaks), _step2; !(_step2 = _iterator2()).done;) {
      var nab = _step2.value;
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, nab.toString());
      for (var _iterator5 = _createForOfIteratorHelperLoose(nab.getAdverts()), _step5; !(_step5 = _iterator5()).done;) {
        var _ad = _step5.value;
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, _ad.toString());
      }
    }
    for (var _iterator3 = _createForOfIteratorHelperLoose(parser.displayAdBreaks), _step3; !(_step3 = _iterator3()).done;) {
      var dab = _step3.value;
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, dab.toString());
      for (var _iterator6 = _createForOfIteratorHelperLoose(dab.getAdverts()), _step6; !(_step6 = _iterator6()).done;) {
        var _ad2 = _step6.value;
        _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, _ad2.toString());
      }
    }
    if (parser.streamData.getEarlyReturn()) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Early return: " + parser.streamData.getEarlyReturn());
    }
    _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "--------------- END PARSING SUMMARY ----------------\n");
  }
}
var AdBreakData = /*#__PURE__*/function () {
  function AdBreakData() {
    this.clear();
  }
  var _proto = AdBreakData.prototype;
  _proto.clear = function clear() {
    this.adverts = [];
    this.timelineTrackingMap = new Map();
    this.trackingEvent = null;
    this.start = 0;
    this.duration = 0;
    this.position = null;
    this.breakType = null;
    this.identifier = null;
    this.earlyReturn = null; // null = not set, -1 error, >= 0 value as successfully parsed
    this.adTagUri = null;
  };
  return AdBreakData;
}();
var AdvertData = /*#__PURE__*/function () {
  function AdvertData() {
    this.clear();
  }
  var _proto2 = AdvertData.prototype;
  _proto2.clear = function clear() {
    this.id = null;
    this.sequence = null;
    this.adType = null;
    this.properties = [];
    this.linearCreative = null;
    this.companionAds = null;
    this.impressions = null;
    this.errors = null;
    this.viewableImpressions = new Map();
    this.adVerifications = [];
    this.filler = false;
    this.nonLinear = false;
    this.topLevelWrapper = null;
    this.extensions = null;
    this.currentCreativeType = CreativeType.NONE;
    this.nonLinearAds = null;
    this.adSystemVersion = null;
    this.advertiserId = null;
    this.categoryAuthority = null;
    this.pricingModel = null;
    this.pricingCurrency = null;
    this.surveyType = null;
    this.verificationVendor = null;
    this.verificationEvents = new Map();
    this.verificationResources = [];
    this.verificationApiFramework = null;
    this.verificationBrowserOptional = null;
    this.verificationParameters = null;
    this.verificationResourceType = null;
    this.extensionStack = [];
  };
  return AdvertData;
}();
exports.AdvertData = AdvertData;
var CompanionAdsData = /*#__PURE__*/function () {
  function CompanionAdsData() {
    this.clear();
  }
  var _proto3 = CompanionAdsData.prototype;
  _proto3.clear = function clear() {
    this.required = null;
    this.companions = [];
  };
  return CompanionAdsData;
}();
var CreativeData = /*#__PURE__*/function () {
  function CreativeData() {
    this.clearAll();
  }
  var _proto4 = CreativeData.prototype;
  _proto4.clear = function clear() {
    this.clickThroughUrl = "";
    this.clickThroughTrackings = [];
    this.clickThroughCustoms = [];
    this.nonLinearResources = [];
    this.duration = null;
    this.trackingMap = new Map();
    this.interactiveTracking = null;
    this.icons = [];
    this.currentAssetUri = null;
    this.skipOffset = null;
    this.adParameters = null;
    this.staticResourceCreativeType = null;
    this.trackingEvent = null;
    this.htmlResourceEncoded = false;
    this.altText = null;
    this.companionExtensionStack = [];
    this.companionExtensions = null;
    this.icSource = null;
    this.properties = [];
  };
  _proto4.clearAll = function clearAll() {
    // Top level
    this.advertId = null;
    this.id = null;
    this.sequence = null;
    this.universalAdIds = [];
    this.universalAdIdRegistry = null;
    this.extensions = null;
    this.extensionStack = [];

    // Per element
    this.clickThroughTrackings = [];
    this.clickThroughUrl = "";
    this.adParameters = null;
    this.trackingEvent = null;

    // Linear data
    this.duration = null;
    this.trackingMap = new Map();
    this.interactiveTracking = null;
    this.icons = [];
    this.currentAssetUri = null;
    this.skipOffset = null;
    this.clickThroughCustoms = [];

    // Non-linear data
    this.nonLinearResources = [];
    this.staticResourceCreativeType = null;
    this.htmlResourceEncoded = null;

    // Companion data
    this.altText = null;
    this.companionExtensions = null;
    this.companionExtensionStack = [];

    // Interactive creative
    this.properties = [];
    this.icSource = null;
  };
  return CreativeData;
}();
exports.CreativeData = CreativeData;
var IconData = /*#__PURE__*/function () {
  function IconData() {
    this.clear();
  }
  var _proto5 = IconData.prototype;
  _proto5.clear = function clear() {
    this.resources = [];
    this.properties = [];
    this.clickThroughUrl = null;
    this.staticResourceCreativeType = null;
    this.clickTrackings = [];
    this.clickFallbackImages = [];
    this.viewTrackings = [];
    this.htmlResourceEncoded = false;
  };
  return IconData;
}();
var IconClickFallbackImageData = /*#__PURE__*/function () {
  function IconClickFallbackImageData() {
    this.clear();
  }
  var _proto6 = IconClickFallbackImageData.prototype;
  _proto6.clear = function clear() {
    this.properties = [];
    this.resource = null;
    this.staticResourceCreativeType = null;
    this.altText = null;
  };
  return IconClickFallbackImageData;
}();
var NonLinearAdsData = /*#__PURE__*/function () {
  function NonLinearAdsData() {
    this.clear();
  }
  var _proto7 = NonLinearAdsData.prototype;
  _proto7.clear = function clear() {
    this.nonLinearCreatives = [];
    this.trackingMap = new Map();
  };
  return NonLinearAdsData;
}();
var StreamData = /*#__PURE__*/function () {
  function StreamData() {
    this.sessionIdentifier = null;
    this.duration = 0;
    this.hostNode = null;
    this.hostSuffix = null;
    this.pdtInitial = null;
    this.pdtStart = null;
    this.pdtEnd = null;
    this.earlyReturn = null;
    this.hasPlaceholder = false;
  }
  var _proto8 = StreamData.prototype;
  _proto8.getSessionIdentifier = function getSessionIdentifier() {
    return this.sessionIdentifier;
  };
  _proto8.getDuration = function getDuration() {
    return this.duration;
  };
  _proto8.getHasPlaceholder = function getHasPlaceholder() {
    return this.hasPlaceholder;
  };
  _proto8.getHostNode = function getHostNode() {
    return this.hostNode;
  };
  _proto8.getHostSuffix = function getHostSuffix() {
    return this.hostSuffix;
  };
  _proto8.getPdtInitial = function getPdtInitial() {
    return this.pdtInitial;
  };
  _proto8.getPdtStart = function getPdtStart() {
    return this.pdtStart;
  };
  _proto8.getPdtEnd = function getPdtEnd() {
    return this.pdtEnd;
  };
  _proto8.getEarlyReturn = function getEarlyReturn() {
    return this.earlyReturn;
  };
  return StreamData;
}();
exports.StreamData = StreamData;
var Parser = /*#__PURE__*/function () {
  function Parser(broker) {
    this.broker = broker;
    this.skipNormalisation = false;

    // vars
    this.linearAdBreaks = [];
    this.nonLinearAdBreaks = [];
    this.displayAdBreaks = [];
    this.isVmap = false;
    this.isValidVAST = true;
    this.processingAdvertExtensions = false;
    this.processingCreativeExtensions = false;
    this.characters = "";

    // Objects
    this.adBreakData = new AdBreakData();
    this.advertData = new AdvertData();
    this.companionAdsData = new CompanionAdsData();
    this.creativeData = new CreativeData();
    this.iconClickFallbackImageData = new IconClickFallbackImageData();
    this.iconData = new IconData();
    this.iconFallbackImageData = new IconClickFallbackImageData();
    this.nonLinearAdsData = new NonLinearAdsData();
    this.streamData = new StreamData();

    // callbacks
    this.onCdata = this.onCdata.bind(this);
    this.onOpenTag = this.onOpenTag.bind(this);
    this.onCloseTag = this.onCloseTag.bind(this);
    this.onText = this.onText.bind(this);
  }
  var _proto9 = Parser.prototype;
  _proto9.addToCreativeExtensionStack = function addToCreativeExtensionStack(node) {
    if (this.advertData.currentCreativeType === CreativeType.COMPANION) {
      this.creativeData.companionExtensionStack.push(node);
    } else {
      this.creativeData.extensionStack.push(node);
    }
  };
  _proto9.checkValidVersion = function checkValidVersion(versionStr) {
    var version = parseFloat(versionStr);
    return !Number.isNaN(version) && version >= MIN_VAST_VERSION;
  };
  _proto9.getStreamData = function getStreamData() {
    return this.streamData;
  };
  _proto9.handleCreativeExtensionsForOnEndDefault = function handleCreativeExtensionsForOnEndDefault(name) {
    var stack = this.advertData.currentCreativeType === CreativeType.COMPANION ? this.creativeData.companionExtensionStack : this.creativeData.extensionStack;
    var size = stack.length;
    if (size === 2) {
      this.pop(false, true);
      this.processingCreativeExtensions = false;
    } else if (size > 0) {
      var node = stack[size - 1];
      if (name === node.getName()) {
        this.pop(false, true);
      }
    }
  };
  _proto9.handleStartAd = function handleStartAd(attributes) {
    this.advertData.id = attributes.id;
    var sequence = parseInt(attributes.sequence);
    this.advertData.sequence = !Number.isNaN(sequence) ? sequence : 0;
    if (!Number.isNaN(sequence)) {
      this.advertData.sequence = sequence;
    }
    this.advertData.adType = attributes.adType;
    if (_AdBreak.AdBreak.getBreakTypeFromString(this.adBreakData.breakType) !== _AdBreak.BreakType.LINEAR) {
      this.advertData.nonLinear = true;
    }
  };
  _proto9.handleStartAdWrapper = function handleStartAdWrapper(attributes) {
    var wrapperId = attributes.id ? attributes.id : "";
    var wrapperCreativeId = attributes.creativeId ? attributes.creativeId : "";
    var wrapperAdSystem = attributes.AdSystem ? attributes.AdSystem : "";
    var advertWrapper = new _AdvertWrapper.AdvertWrapper(wrapperId, wrapperCreativeId, wrapperAdSystem);
    if (this.advertData.topLevelWrapper) {
      advertWrapper.setChild(this.advertData.topLevelWrapper);
    }
    this.advertData.topLevelWrapper = advertWrapper;
  };
  _proto9.handleStartCreative = function handleStartCreative(attributes) {
    this.creativeData.advertId = attributes.adId;
    this.creativeData.id = attributes.id;
    var seq = parseInt(attributes.sequence);
    this.creativeData.sequence = isNaN(seq) ? 0 : seq;
  };
  _proto9.handleStartCreativeExtension = function handleStartCreativeExtension(attributes, tag) {
    var type = attributes.type;
    type = type ? type : "";
    if (type.indexOf('com.yospace') === -1 && type.indexOf("AdVerifications") === -1) {
      this.processingCreativeExtensions = true;
      this.addToCreativeExtensionStack(new _XmlNode.XmlNode(tag.name, (0, _CollectionUtils.objectToMap)(attributes)));
    }
  };
  _proto9.handleStartExtension = function handleStartExtension(attributes, tag) {
    var type = attributes.type;
    type = type ? type : "";
    if (type.indexOf("com.yospace") === -1 && type.indexOf("AdVerifications") === -1) {
      this.processingAdvertExtensions = true;
      this.advertData.extensionStack.push(new _XmlNode.XmlNode(tag.name, (0, _CollectionUtils.objectToMap)(attributes)));
    }
  };
  _proto9.handleStartExtensionElement = function handleStartExtensionElement(attributes, tag) {
    if (this.processingAdvertExtensions) {
      this.advertData.extensionStack.push(new _XmlNode.XmlNode(tag.name, (0, _CollectionUtils.objectToMap)(attributes)));
    } else if (this.processingCreativeExtensions) {
      this.addToCreativeExtensionStack(new _XmlNode.XmlNode(tag.name, (0, _CollectionUtils.objectToMap)(attributes)));
    }
  };
  _proto9.handleStartHtmlResource = function handleStartHtmlResource(attributes) {
    var boolString = attributes.xmlEncoded;
    var encoded = boolString ? boolString.toUpperCase() === "TRUE" || boolString === "1" : false;
    if (this.iconData.properties.length > 0) {
      this.iconData.htmlResourceEncoded = encoded;
    } else {
      this.creativeData.htmlResourceEncoded = encoded;
    }
  };
  _proto9.handleStartPricing = function handleStartPricing(attributes) {
    var model = attributes.model;
    if (model) {
      this.advertData.pricingModel = model.toUpperCase();
    } else {
      this.advertData.pricingModel = "";
    }
    this.advertData.pricingCurrency = attributes.currency;
  };
  _proto9.handleStartStaticResource = function handleStartStaticResource(attributes) {
    if (this.iconClickFallbackImageData.properties.length > 0) {
      this.iconClickFallbackImageData.staticResourceCreativeType = attributes.creativeType;
    } else if (this.iconData.properties.length > 0) {
      this.iconData.staticResourceCreativeType = attributes.creativeType;
    } else {
      this.creativeData.staticResourceCreativeType = attributes.creativeType;
    }
  };
  _proto9.handleStartTracking = function handleStartTracking(attributes) {
    this.creativeData.trackingEvent = attributes.event;
    if (this.creativeData.trackingEvent === "progress") {
      var offset = attributes.offset;
      if (!(0, _StringUtils.isNullOrEmpty)(offset)) {
        this.creativeData.trackingEvent = this.creativeData.trackingEvent + "-" + offset;
      }
    }
  };
  _proto9.handleEndAd = function handleEndAd() {
    var advert = new _Advert.Advert(this.advertData);
    if (advert.isValid()) {
      this.adBreakData.adverts.push(advert);
    } else {
      _YoLog.YoLog.w("Invalid advert.  Discarding (" + this.advertData.id + ")");
    }
    this.advertData.clear();
  };
  _proto9.handleAdvertExtensionsForOnEndDefault = function handleAdvertExtensionsForOnEndDefault(name) {
    var size = this.advertData.extensionStack.length;
    if (size === 2) {
      this.pop(true, true);
      this.processingAdvertExtensions = false;
    } else if (size > 0) {
      var node = this.advertData.extensionStack[size - 1];
      if (name === node.getName()) {
        this.pop(true, true);
      }
    }
  };
  _proto9.handleEndAdTitle = function handleEndAdTitle() {
    var title = this.characters.trim();
    this.advertData.properties.push(new _VASTProperty.VASTProperty("AdTitle", title));
    if (title === "filler") {
      this.advertData.filler = true;
    }
  };
  _proto9.handleEndClickTracking = function handleEndClickTracking() {
    var characters = this.characters.trim();
    if ((0, _HttpUtils.getUrl)(characters)) {
      this.creativeData.clickThroughTrackings.push(characters);
    } else {
      _YoLog.YoLog.w("Discarding click tracking URL:" + characters);
    }
  };
  _proto9.handleEndCompanion = function handleEndCompanion() {
    var videoClicks = null;
    if (!(0, _StringUtils.isNullOrEmpty)(this.creativeData.clickThroughUrl)) {
      videoClicks = new _VideoClicks.VideoClicks(this.creativeData.clickThroughUrl, this.creativeData.clickThroughTrackings, null);
    }
    var companion = new _CompanionCreative.CompanionCreative(this.creativeData, videoClicks, this.creativeData.nonLinearResources, this.creativeData.trackingMap, this.broker);
    if (companion.isValid()) {
      companion.setNonLinear(this.advertData.nonLinear);
      this.companionAdsData.companions.push(companion);
    } else {
      _YoLog.YoLog.w("Discarding invalid Companion");
    }
    this.creativeData.clear();
  };
  _proto9.handleEndCompanionClickTracking = function handleEndCompanionClickTracking() {
    var characters = this.characters.trim();
    if ((0, _HttpUtils.getUrl)(characters)) {
      this.creativeData.clickThroughTrackings.push(characters);
    } else {
      _YoLog.YoLog.w("Discarding empty Companion click tracking URL");
    }
  };
  _proto9.handleEndCreative = function handleEndCreative() {
    this.creativeData.clearAll();
  };
  _proto9.handleEndCustomClick = function handleEndCustomClick() {
    var characters = this.characters.trim();
    if (characters !== "") {
      this.creativeData.clickThroughCustoms.push(characters);
    } else {
      _YoLog.YoLog.w("Discarding empty custom click URL");
    }
  };
  _proto9.handleEndError = function handleEndError(name) {
    var characters = this.characters.trim();
    if ((0, _HttpUtils.getUrl)(characters)) {
      if (!this.advertData.errors) {
        this.advertData.errors = new _TrackingReport.TrackingReport(name, [characters]);
      } else {
        this.advertData.errors.addTrackingUrl(characters);
      }
    } else {
      _YoLog.YoLog.w("Discarding empty Error");
    }
  };
  _proto9.handleEndExecutableResource = function handleEndExecutableResource() {
    if (this.advertData.verificationApiFramework && this.advertData.verificationResourceType) {
      var prop = new _VASTProperty.VASTProperty("ExecutableResource", this.characters.trim(), "apiFramework", this.advertData.verificationApiFramework);
      prop.addAttribute("type", this.advertData.verificationResourceType);
      this.advertData.verificationResources.push(prop);
    }
    this.advertData.verificationApiFramework = null;
    this.advertData.verificationResourceType = null;
  };
  _proto9.handleEndIcon = function handleEndIcon() {
    var videoClicks = null;
    if (!(0, _StringUtils.isNullOrEmpty)(this.iconData.clickThroughUrl) || this.iconData.viewTrackings.length > 0) {
      if ((0, _StringUtils.isNullOrEmpty)(this.iconData.clickThroughUrl)) {
        videoClicks = new _VideoClicks.VideoClicks(null, null, this.iconData.viewTrackings);
      } else {
        videoClicks = new _VideoClicks.VideoClicks(this.iconData.clickThroughUrl, this.iconData.clickTrackings, this.iconData.viewTrackings);
      }
    }
    var icon = new _IndustryIcon.IndustryIcon(this.iconData.properties, this.iconData.resources, videoClicks, this.iconData.clickFallbackImages, this.broker);
    if (icon.isValid()) {
      this.creativeData.icons.push(icon);
    } else {
      _YoLog.YoLog.w("Discarding invalid Icon");
    }
    this.iconData.clear();
  };
  _proto9.handleEndIFrameResource = function handleEndIFrameResource() {
    var characters = this.characters.trim();
    if (this.iconData.properties.length > 0) {
      this.iconData.resources.push(new _Resource.Resource(_Resource.ResourceType.IFRAME, characters));
    } else {
      this.creativeData.nonLinearResources.push(new _Resource.Resource(_Resource.ResourceType.IFRAME, characters));
    }
  };
  _proto9.handleEndExtensionElement = function handleEndExtensionElement(name) {
    if (this.processingAdvertExtensions) {
      this.handleAdvertExtensionsForOnEndDefault(name);
    } else {
      this.handleCreativeExtensionsForOnEndDefault(name);
    }
  };
  _proto9.handleEndHtmlResource = function handleEndHtmlResource() {
    if (this.iconData.properties.length > 0) {
      var characters = this.characters.trim();
      this.iconData.resources.push(new _Resource.Resource(_Resource.ResourceType.HTML, characters, null, this.iconData.htmlResourceEncoded));
    } else {
      this.creativeData.nonLinearResources.push(new _Resource.Resource(_Resource.ResourceType.HTML, this.characters, null, this.creativeData.htmlResourceEncoded));
    }
  };
  _proto9.handleEndIconClickFallbackImage = function handleEndIconClickFallbackImage() {
    var iconClickFallbackImage = new _IconClickFallbackImage.IconClickFallbackImage(this.iconClickFallbackImageData.properties, this.iconClickFallbackImageData.altText, this.iconClickFallbackImageData.resource);
    if (iconClickFallbackImage.isValid()) {
      this.iconData.clickFallbackImages.push(iconClickFallbackImage);
    } else {
      _YoLog.YoLog.w("Discarding invalid IconClickFallbackImage");
    }
    this.iconClickFallbackImageData.clear();
  };
  _proto9.handleEndIconClickTracking = function handleEndIconClickTracking() {
    var characters = this.characters.trim();
    if ((0, _HttpUtils.getUrl)(characters)) {
      this.iconData.clickTrackings.push(characters);
    } else {
      _YoLog.YoLog.w("Discarding empty Icon click tracking URL");
    }
  };
  _proto9.handleEndIconViewTracking = function handleEndIconViewTracking() {
    var characters = this.characters.trim();
    if ((0, _HttpUtils.getUrl)(characters)) {
      this.iconData.viewTrackings.push(characters);
    } else {
      _YoLog.YoLog.w("Discarding empty Icon view tracking URL");
    }
  };
  _proto9.handleEndInteractiveTracking = function handleEndInteractiveTracking() {
    if (!this.creativeData.interactiveTracking) {
      this.creativeData.interactiveTracking = new _TrackingReport.TrackingReport(this.creativeData.trackingEvent, [this.characters.trim()]);
    } else {
      this.creativeData.interactiveTracking.addTrackingUrl(this.characters.trim());
    }
  };
  _proto9.handleEndLinear = function handleEndLinear() {
    var videoClicks = null;
    if (!(0, _StringUtils.isNullOrEmpty)(this.creativeData.clickThroughUrl) || this.creativeData.clickThroughCustoms.length > 0) {
      if ((0, _StringUtils.isNullOrEmpty)(this.creativeData.clickThroughUrl)) {
        videoClicks = new _VideoClicks.VideoClicks(null, null, this.creativeData.clickThroughCustoms);
      } else {
        videoClicks = new _VideoClicks.VideoClicks(this.creativeData.clickThroughUrl, this.creativeData.clickThroughTrackings, this.creativeData.clickThroughCustoms);
      }
    }
    var ic = null;
    if (this.creativeData.properties.length > 0) {
      ic = new _InteractiveCreative.InteractiveCreative(this.creativeData.icSource, this.creativeData.properties, this.broker, this.creativeData.interactiveTracking);
      if (!ic.isValid()) {
        _YoLog.YoLog.w("Discarding invalid InteractiveCreative");
        ic = null;
      }
    }
    var lc = new _LinearCreative.LinearCreative(this.creativeData, videoClicks, ic, this.broker);
    if (lc.isValid()) {
      this.advertData.linearCreative = lc;
    } else {
      _YoLog.YoLog.w("Discarding invalid LinearCreative");
    }
    this.creativeData.clear();
  };
  _proto9.handleEndImpression = function handleEndImpression(name) {
    var characters = this.characters.trim();
    if ((0, _HttpUtils.getUrl)(characters)) {
      if (!this.advertData.impressions) {
        this.advertData.impressions = new _TrackingReport.TrackingReport(name, [characters]);
      } else {
        this.advertData.impressions.addTrackingUrl(characters);
      }
    } else {
      _YoLog.YoLog.w("Discarding empty Impression");
    }
  };
  _proto9.handleEndInteractiveCreativeFile = function handleEndInteractiveCreativeFile() {
    this.creativeData.icSource = this.characters.trim();
  };
  _proto9.handleEndJavaScriptResource = function handleEndJavaScriptResource() {
    if (this.advertData.verificationApiFramework && this.advertData.verificationBrowserOptional) {
      var prop = new _VASTProperty.VASTProperty(JAVASCRIPT_RESOURCE_TOKEN, this.characters.trim(), "apiFramework", this.advertData.verificationApiFramework);
      prop.addAttribute("browserOptional", this.advertData.verificationBrowserOptional);
      this.advertData.verificationResources.push(prop);
    }
    this.advertData.verificationApiFramework = null;
    this.advertData.verificationBrowserOptional = null;
  };
  _proto9.handleEndMediaFile = function handleEndMediaFile() {
    if (this.creativeData.properties.length !== 0) {
      this.creativeData.icSource = this.characters.trim();
    } else {
      this.creativeData.currentAssetUri = this.characters.trim();
    }
  };
  _proto9.handleEndNonLinearClickTracking = function handleEndNonLinearClickTracking() {
    var characters = this.characters.trim();
    if ((0, _HttpUtils.getUrl)(characters)) {
      this.creativeData.clickThroughTrackings.push(characters);
    } else {
      _YoLog.YoLog.w("Discarding empty Nonlinear click tracking URL");
    }
  };
  _proto9.handleEndPricing = function handleEndPricing() {
    var characters = this.characters.trim();
    if (characters !== "") {
      var prop = new _VASTProperty.VASTProperty(PRICING_TOKEN, characters, "currency", this.advertData.pricingCurrency);
      prop.addAttribute("model", this.advertData.pricingModel);
      if (!(0, _StringUtils.isNullOrEmpty)(this.advertData.pricingCurrency) && !(0, _StringUtils.isNullOrEmpty)(this.advertData.pricingModel)) {
        this.advertData.properties.push(prop);
      } else {
        _YoLog.YoLog.w("Discarding invalid Pricing property");
      }
    } else {
      _YoLog.YoLog.w("Discarding invalid Pricing property");
    }
  };
  _proto9.handleEndUniversalAdId = function handleEndUniversalAdId() {
    var characters = this.characters.trim();
    if (characters !== "") {
      this.creativeData.universalAdIds.push(new _VASTProperty.VASTProperty(UNIVERSAL_AD_ID_TOKEN, characters, "idRegistry", this.creativeData.universalAdIdRegistry));
    } else {
      _YoLog.YoLog.w("Discarding empty UniversalAdId URL");
    }
  };
  _proto9.handleEndVerification = function handleEndVerification() {
    var adVerification = new _AdVerification.AdVerification(this.advertData);
    if (adVerification.isValid()) {
      this.advertData.adVerifications.push(adVerification);
    } else {
      _YoLog.YoLog.w("Discarding invalid AdVerification");
    }
    this.advertData.verificationEvents = new Map();
    this.advertData.verificationResources = [];
    this.advertData.verificationParameters = null;
  };
  _proto9.handleEndVmapTracking = function handleEndVmapTracking() {
    var characters = this.characters.trim();
    if (!_TrackingReport.TrackingReport.isValidAdBreakEvent(this.adBreakData.trackingEvent)) {
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_PARSING, "Discarding invalid vmap:Tracking event");
    } else {
      if (!(0, _StringUtils.isNullOrEmpty)(characters)) {
        var report = this.adBreakData.timelineTrackingMap.get(this.adBreakData.trackingEvent);
        if (!report) {
          report = new _TrackingReport.TrackingReport(this.adBreakData.trackingEvent, [characters]);
          this.adBreakData.timelineTrackingMap.set(this.adBreakData.trackingEvent, report);
        } else {
          report.addTrackingUrl(characters);
        }
      } else {
        _YoLog.YoLog.w("Discarding empty VMAP");
      }
    }
  };
  _proto9.handleEndNonLinear = function handleEndNonLinear() {
    var videoClicks = null;
    if (this.creativeData.clickThroughUrl && this.creativeData.clickThroughUrl !== "") {
      videoClicks = new _VideoClicks.VideoClicks(this.creativeData.clickThroughUrl, this.creativeData.clickThroughTrackings, null);
    }
    var creative = new _NonLinearCreative.NonLinearCreative(this.creativeData, videoClicks, this.creativeData.nonLinearResources, this.broker);
    if (creative.isValid()) {
      creative.setNonLinear(this.advertData.nonLinear);
      this.nonLinearAdsData.nonLinearCreatives.push(creative);
    } else {
      _YoLog.YoLog.w("Discarding invalid NonLinear");
    }
    this.creativeData.clear();
  };
  _proto9.handleEndStaticResource = function handleEndStaticResource() {
    var characters = this.characters.trim();
    if (this.iconClickFallbackImageData.properties.length > 0) {
      var res = new _Resource.Resource(_Resource.ResourceType.STATIC, characters, this.iconClickFallbackImageData.staticResourceCreativeType);
      if (res.isValid()) {
        this.iconClickFallbackImageData.resource = res;
        return;
      }
    } else if (this.iconData.properties.length > 0) {
      var _res = new _Resource.Resource(_Resource.ResourceType.STATIC, characters, this.iconData.staticResourceCreativeType);
      if (_res.isValid()) {
        this.iconData.resources.push(_res);
        return;
      }
    } else {
      var _res2 = new _Resource.Resource(_Resource.ResourceType.STATIC, characters, this.creativeData.staticResourceCreativeType);
      if (_res2.isValid()) {
        this.creativeData.nonLinearResources.push(_res2);
        return;
      }
    }
    _YoLog.YoLog.w("Discarding invalid StaticResource");
  };
  _proto9.handleEndTracking = function handleEndTracking() {
    var characters = this.characters.trim();
    if (!(0, _StringUtils.isNullOrEmpty)((0, _HttpUtils.getUrl)(characters))) {
      var map = null;
      if (_TrackingReport.TrackingReport.isValidVerificationEvent(this.creativeData.trackingEvent)) {
        map = this.advertData.verificationEvents;
      } else if (this.advertData.currentCreativeType === CreativeType.LINEAR && _TrackingReport.TrackingReport.isValidLinearEvent(this.creativeData.trackingEvent) || this.creativeData.trackingEvent.indexOf("progress") === 0) {
        map = this.creativeData.trackingMap;
      } else if (this.advertData.currentCreativeType === CreativeType.LINEAR && _TrackingReport.TrackingReport.isValidInteractiveEvent(this.creativeData.trackingEvent)) {
        this.handleEndInteractiveTracking();
      } else if (this.advertData.currentCreativeType === CreativeType.COMPANION && _TrackingReport.TrackingReport.isValidCompanionEvent(this.creativeData.trackingEvent)) {
        map = this.creativeData.trackingMap;
      } else if (this.advertData.currentCreativeType === CreativeType.NONLINEAR && _TrackingReport.TrackingReport.isValidNonLinearEvent(this.creativeData.trackingEvent)) {
        map = this.nonLinearAdsData.trackingMap;
      }
      if (map) {
        this.parseMapForOnEndTracking(map);
      }
    } else {
      _YoLog.YoLog.w("Discarding empty tracking URL");
    }
  };
  _proto9.handleEndViewableImpression = function handleEndViewableImpression(name) {
    var characters = this.characters.trim();
    if (!(0, _StringUtils.isNullOrEmpty)((0, _HttpUtils.getUrl)(characters))) {
      var report = this.advertData.viewableImpressions.get(name);
      if (!report) {
        report = new _TrackingReport.TrackingReport(name, [characters]);
        this.advertData.viewableImpressions.set(name, report);
      } else {
        report.addTrackingUrl(characters);
      }
    } else {
      _YoLog.YoLog.w("Discarding empty ViewableImpression URL");
    }
  };
  _proto9.handleTextDataForExtensions = function handleTextDataForExtensions() {
    var characters = this.characters.trim();
    if (characters !== "") {
      var stack = [];
      if (this.processingAdvertExtensions) {
        stack = this.advertData.extensionStack;
      } else {
        stack = this.advertData.currentCreativeType === CreativeType.COMPANION ? this.creativeData.companionExtensionStack : this.creativeData.extensionStack;
      }
      if (stack.length > 0) {
        var node = stack[stack.length - 1];
        node.setInnerText(characters);
      }
    }
  };
  _proto9.handleVmapAdBreak = function handleVmapAdBreak() {
    // If early return is not null, discard the ad break.
    if (this.adBreakData.earlyReturn !== null) {
      // Set this so that a new adbreak won't be created due to a subsequent vmap ad break section
      this.streamData.earlyReturn = this.adBreakData.earlyReturn;
      this.adBreakData.clear();
      return;
    }
    if (_AdBreak.AdBreak.getBreakTypeFromString(this.adBreakData.breakType) === _AdBreak.BreakType.LINEAR && !this.skipNormalisation) {
      // Get the normalised position of the ad break in case there is an overlap or a gap
      this.adBreakData.start = this.broker.normaliseAdBreakStart(this.adBreakData.start, this.adBreakData.position);
    }
    var ab = new _AdBreak.AdBreak(this.adBreakData.start, this.adBreakData.duration, this.adBreakData.position, this.adBreakData.timelineTrackingMap, this.adBreakData.breakType, this.adBreakData.identifier, null, this.adBreakData.adTagUri);
    if (this.adBreakData.adverts.length > 0) {
      ab.setAdverts(this.adBreakData.adverts);
    }
    ab.postParse(this.broker);
    if (ab.isValid()) {
      var breakType = _AdBreak.AdBreak.getBreakTypeFromString(this.adBreakData.breakType);
      switch (breakType) {
        case _AdBreak.BreakType.LINEAR:
          this.linearAdBreaks.push(ab);
          break;
        case _AdBreak.BreakType.NONLINEAR:
          this.nonLinearAdBreaks.push(ab);
          break;
        case _AdBreak.BreakType.DISPLAY:
          this.displayAdBreaks.push(ab);
          break;
      }
    } else {
      var fragment = this.streamData.hasPlaceholder ? " placeholder " : " ";
      _YoLog.YoLog.w("Discarding empty" + fragment + "ad break");
    }
    this.adBreakData.clear();
  };
  _proto9.handleVmapAdTagURI = function handleVmapAdTagURI() {
    this.streamData.hasPlaceholder = true;
    this.adBreakData.adTagUri = this.characters.trim();
  };
  _proto9.handleYospaceAdBreak = function handleYospaceAdBreak(attributes) {
    var durationAttr = attributes.duration;
    if (durationAttr) {
      this.adBreakData.duration = (0, _ConversionUtils.timeStringToMillis)(durationAttr);
    }
    var positionAttr = attributes.position;
    if (positionAttr) {
      this.adBreakData.position = positionAttr;
    }
    var earlyReturnAttr = attributes.earlyReturn;
    if (earlyReturnAttr) {
      var earlyReturn = (0, _ConversionUtils.timeStringToMillis)(earlyReturnAttr, -1);
      // This is an offset relative to ad break start
      this.adBreakData.earlyReturn = earlyReturn !== -1 ? earlyReturn + this.adBreakData.start : -1;
    }
  };
  _proto9.handleYospaceStream = function handleYospaceStream(attributes) {
    var urlDomainAttr = attributes.urlDomain;
    if (urlDomainAttr) {
      this.streamData.hostNode = urlDomainAttr;
    }
    var hostSuffixAttr = attributes.urlSuffix;
    if (hostSuffixAttr) {
      this.streamData.hostSuffix = hostSuffixAttr;
    }
    var durationAttr = attributes.duration;
    if (durationAttr) {
      var duration = (0, _ConversionUtils.timeStringToMillis)(attributes.duration);
      if (duration) {
        this.streamData.duration = duration;
      }
    }

    // Try to find the session identifier
    if (this.streamData.hostSuffix) {
      var match = this.streamData.hostSuffix.match(YOPSI_PATTERN);
      if (match) {
        this.streamData.sessionIdentifier = match[1];
      }
    }

    // yyyy-MM-dd'T'HH:mm:ss.SSS
    this.streamData.pdtInitial = (0, _ConversionUtils.pdtToMillis)(attributes.pdtinitial, null);
    this.streamData.pdtStart = (0, _ConversionUtils.pdtToMillis)(attributes.pdtstart, null);
    this.streamData.pdtEnd = (0, _ConversionUtils.pdtToMillis)(attributes.pdtend, null);
    if (this.streamData.pdtStart === null || this.streamData.pdtEnd === null || this.streamData.pdtStart > this.streamData.pdtEnd) {
      this.streamData.pdtStart = null;
      this.streamData.pdtEnd = null;
      this.streamData.pdtInitial = null;
    }
  };
  _proto9.onCdata = function onCdata(data) {
    this.characters = data;
    if (this.processingAdvertExtensions || this.processingCreativeExtensions) {
      this.handleTextDataForExtensions();
    }
  };
  _proto9.onOpenTag = function onOpenTag(tag) {
    var attributes = tag.attributes;
    if (this.processingAdvertExtensions || this.processingCreativeExtensions) {
      this.handleStartExtensionElement(attributes, tag);
      return;
    }
    if (tag.name === VMAP_TOKEN) {
      this.isVmap = true;
    }
    if (tag.name === YOSPACE_STREAM_TOKEN) {
      this.handleYospaceStream(attributes);
    }
    if (tag.name === VMAP_ADBREAK_TOKEN) {
      var timeOffsetAttr = attributes.timeOffset;
      if (timeOffsetAttr) {
        this.adBreakData.start = (0, _ConversionUtils.timeStringToMillis)(timeOffsetAttr, -1);
      }
      var breakTypeAttr = attributes.breakType;
      if (breakTypeAttr) {
        this.adBreakData.breakType = breakTypeAttr;
      }
      var breakIdAttr = attributes.breakId;
      if (breakIdAttr) {
        this.adBreakData.identifier = breakIdAttr;
      }
    }
    if (tag.name === YOSPACE_ADBREAK_TOKEN) {
      this.handleYospaceAdBreak(attributes);
    }
    if (tag.name === VMAP_TRACKING_TOKEN) {
      this.adBreakData.trackingEvent = attributes.event;
    }
    if (tag.name === VAST_TOKEN) {
      var vastVersionStr = attributes.version;
      if (!this.checkValidVersion(vastVersionStr)) {
        _YoLog.YoLog.e("Invalid or missing VAST version; is AV tag defined?");
        this.isValidVAST = false;
      }
    }
    if (tag.name === AD_TOKEN) {
      this.handleStartAd(attributes);
    }
    if (tag.name === AD_WRAPPER_TOKEN) {
      this.handleStartAdWrapper(attributes);
    }
    if (tag.name === CATEGORY_TOKEN) {
      this.advertData.categoryAuthority = attributes.authority;
    }
    if (tag.name === AD_SYSTEM_TOKEN) {
      this.advertData.adSystemVersion = attributes.version;
    }
    if (tag.name === ADVERTISER_TOKEN) {
      this.advertData.advertiserId = attributes.id;
    }
    if (tag.name === SURVEY_TOKEN) {
      this.advertData.surveyType = attributes.type;
    }
    if (tag.name === PRICING_TOKEN) {
      this.handleStartPricing(attributes);
    }
    if (tag.name === UNIVERSAL_AD_ID_TOKEN) {
      this.creativeData.universalAdIdRegistry = attributes.idRegistry;
    }
    if (tag.name === EXTENSIONS_TOKEN) {
      this.advertData.extensionStack.push(new _XmlNode.XmlNode(tag.name, (0, _CollectionUtils.objectToMap)(attributes)));
    }
    if (tag.name === CREATIVE_TOKEN) {
      this.handleStartCreative(attributes);
    }
    if (tag.name === LINEAR_TOKEN) {
      this.advertData.currentCreativeType = CreativeType.LINEAR;
      this.creativeData.skipOffset = attributes.skipoffset;
    }
    if (tag.name === ICON_TOKEN) {
      this.populateIconPropertyList(attributes);
    }
    if (tag.name === ICON_CLICK_FALLBACK_IMAGE_TOKEN) {
      this.populateIconClickFallbackImagePropertyList(attributes);
    }
    if (tag.name === AD_PARAMETERS_TOKEN) {
      this.creativeData.adParameters = new _VASTProperty.VASTProperty(AD_PARAMETERS_TOKEN, null, "xmlEncoded", attributes.xmlEncoded);
    }
    if (tag.name === INTERACTIVE_CREATIVE_FILE_TOKEN) {
      this.populateInteractiveCreativePropertyList(attributes);
    }
    if (tag.name === NON_LINEAR_ADS_TOKEN) {
      this.advertData.currentCreativeType = CreativeType.NONLINEAR;
    }
    if (tag.name === NON_LINEAR_TOKEN) {
      this.populateNonLinearPropertyList(attributes);
    }
    if (tag.name === COMPANION_ADS_TOKEN) {
      this.advertData.currentCreativeType = CreativeType.COMPANION;
      this.companionAdsData.required = attributes.required;
    }
    if (tag.name === COMPANION_TOKEN) {
      this.populateCompanionPropertyList(attributes);
    }
    if (tag.name === STATIC_RESOURCE_TOKEN) {
      this.handleStartStaticResource(attributes);
    }
    if (tag.name === HTML_RESOURCE_TOKEN) {
      this.handleStartHtmlResource(attributes);
    }
    if (tag.name === TRACKING_TOKEN) {
      this.handleStartTracking(attributes);
    }
    if (tag.name === VERIFICATION_TOKEN) {
      this.advertData.verificationVendor = attributes.vendor;
    }
    if (tag.name === JAVASCRIPT_RESOURCE_TOKEN) {
      this.advertData.verificationApiFramework = attributes.apiFramework;
      this.advertData.verificationBrowserOptional = attributes.browserOptional;
    }
    if (tag.name === EXECUTABLE_RESOURCE_TOKEN) {
      this.advertData.verificationApiFramework = attributes.apiFramework;
      this.advertData.verificationResourceType = attributes.type;
    }
    if (tag.name === EXTENSION_TOKEN) {
      this.handleStartExtension(attributes, tag);
    }
    if (tag.name === CREATIVE_EXTENSIONS_TOKEN) {
      this.addToCreativeExtensionStack(new _XmlNode.XmlNode(tag.name, (0, _CollectionUtils.objectToMap)(attributes)));
    }
    if (tag.name === CREATIVE_EXTENSION_TOKEN) {
      this.handleStartCreativeExtension(attributes, tag);
    }
    if (tag.isSelfClosing) {
      this.onCloseTag(tag);
    }
  };
  _proto9.onCloseTag = function onCloseTag(tag) {
    if (this.processingAdvertExtensions || this.processingCreativeExtensions) {
      this.handleEndExtensionElement(tag);
      this.characters = "";
      return;
    }
    if (tag === VMAP_ADBREAK_TOKEN) {
      this.handleVmapAdBreak();
    }
    if (tag === VMAP_TRACKING_TOKEN) {
      this.handleEndVmapTracking();
    }
    if (tag === AD_TOKEN) {
      this.handleEndAd();
    }
    if (tag === AD_SYSTEM_TOKEN) {
      this.advertData.properties.push(new _VASTProperty.VASTProperty("AdSystem", this.characters.trim(), "version", this.advertData.adSystemVersion));
    }
    if (tag === AD_TITLE_TOKEN) {
      this.handleEndAdTitle();
    }
    if (tag === IMPRESSION_TOKEN) {
      this.handleEndImpression(tag);
    }
    if (tag === AD_SERVING_ID_TOKEN) {
      this.advertData.properties.push(new _VASTProperty.VASTProperty(AD_SERVING_ID_TOKEN, this.characters.trim()));
    }
    if (tag === CATEGORY_TOKEN) {
      this.advertData.properties.push(new _VASTProperty.VASTProperty(CATEGORY_TOKEN, this.characters.trim(), "authority", this.advertData.categoryAuthority));
    }
    if (tag === DESCRIPTION_TOKEN) {
      this.advertData.properties.push(new _VASTProperty.VASTProperty(DESCRIPTION_TOKEN, this.characters.trim()));
    }
    if (tag === ADVERTISER_TOKEN) {
      this.advertData.properties.push(new _VASTProperty.VASTProperty(ADVERTISER_TOKEN, this.characters.trim(), "id", this.advertData.advertiserId));
    }
    if (tag === SURVEY_TOKEN) {
      this.advertData.properties.push(new _VASTProperty.VASTProperty(SURVEY_TOKEN, this.characters.trim(), "type", this.advertData.surveyType));
    }
    if (tag === ERROR_TOKEN) {
      this.handleEndError(tag);
    }
    if (tag === PRICING_TOKEN) {
      this.handleEndPricing();
    }
    if (tag === UNIVERSAL_AD_ID_TOKEN) {
      this.handleEndUniversalAdId();
    }
    if (tag === EXTENSIONS_TOKEN) {
      this.pop(true, false);
    }
    if (tag === CREATIVE_EXTENSIONS_TOKEN) {
      this.pop(false, false);
    }
    if (tag === VERIFICATION_TOKEN) {
      this.handleEndVerification();
    }
    if (tag === VERIFICATION_PARAMETERS_TOKEN) {
      this.advertData.verificationParameters = this.characters.trim();
    }
    if (tag === MEDIAFILE_TOKEN) {
      this.handleEndMediaFile();
    }
    if (tag === INTERACTIVE_CREATIVE_FILE_TOKEN) {
      this.handleEndInteractiveCreativeFile();
    }
    if (tag === CLICK_THROUGH_TOKEN || tag === NON_LINEAR_CLICK_THROUGH_TOKEN || tag === COMPANION_CLICK_THROUGH_TOKEN) {
      this.creativeData.clickThroughUrl = this.characters.trim();
    }
    if (tag === ICON_CLICK_THROUGH_TOKEN) {
      this.iconData.clickThroughUrl = this.characters.trim();
    }
    if (tag === CLICK_TRACKING_TOKEN) {
      this.handleEndClickTracking();
    }
    if (tag === NON_LINEAR_CLICK_TRACKING_TOKEN) {
      this.handleEndNonLinearClickTracking();
    }
    if (tag === COMPANION_CLICK_TRACKING_TOKEN) {
      this.handleEndCompanionClickTracking();
    }
    if (tag === ICON_CLICK_TRACKING_TOKEN) {
      this.handleEndIconClickTracking();
    }
    if (tag === ICON_CLICK_FALLBACK_IMAGE_TOKEN) {
      this.handleEndIconClickFallbackImage();
    }
    if (tag === ALT_TEXT_TOKEN) {
      if (this.iconClickFallbackImageData.properties.length > 0) {
        this.iconClickFallbackImageData.altText = this.characters.trim();
      } else {
        this.creativeData.altText = this.characters.trim();
      }
    }
    if (tag === CUSTOM_CLICK) {
      this.handleEndCustomClick();
    }
    if (tag === ICON_VIEW_TRACKING_TOKEN) {
      this.handleEndIconViewTracking();
    }
    if (tag === CREATIVE_TOKEN) {
      this.handleEndCreative();
    }
    if (tag === LINEAR_TOKEN) {
      this.handleEndLinear();
    }
    if (tag === NON_LINEAR_ADS_TOKEN) {
      this.advertData.nonLinearAds = new _NonLinearAds.NonLinearAds(this.nonLinearAdsData.trackingMap, this.nonLinearAdsData.nonLinearCreatives);
      this.nonLinearAdsData.clear();
    }
    if (tag === NON_LINEAR_TOKEN) {
      this.handleEndNonLinear();
    }
    if (tag === COMPANION_ADS_TOKEN) {
      this.advertData.companionAds = new _CompanionAds.CompanionAds(this.companionAdsData.required, this.companionAdsData.companions);
      this.companionAdsData.clear();
    }
    if (tag === COMPANION_TOKEN) {
      this.handleEndCompanion();
    }
    if (tag === ICON_TOKEN) {
      this.handleEndIcon();
    }
    if (tag === AD_PARAMETERS_TOKEN) {
      this.creativeData.adParameters.setValue(this.characters.trim());
    }
    if (tag === DURATION_TOKEN) {
      this.creativeData.duration = this.characters.trim();
    }
    if (tag === VIEWABLE_TOKEN || tag === NOT_VIEWABLE_TOKEN || tag === VIEW_UNDETERMINED_TOKEN) {
      this.handleEndViewableImpression(tag);
    }
    if (tag === STATIC_RESOURCE_TOKEN) {
      this.handleEndStaticResource();
    }
    if (tag === HTML_RESOURCE_TOKEN) {
      this.handleEndHtmlResource();
    }
    if (tag === IFRAME_RESOURCE_TOKEN) {
      this.handleEndIFrameResource();
    }
    if (tag === TRACKING_TOKEN) {
      this.handleEndTracking();
    }
    if (tag === JAVASCRIPT_RESOURCE_TOKEN) {
      this.handleEndJavaScriptResource();
    }
    if (tag === EXECUTABLE_RESOURCE_TOKEN) {
      this.handleEndExecutableResource();
    }
    if (tag === VMAP_ADTAG_URI) {
      this.handleVmapAdTagURI();
    }
  };
  _proto9.onText = function onText(text) {
    this.characters = text;
    if (this.processingAdvertExtensions || this.processingCreativeExtensions) {
      this.handleTextDataForExtensions();
    }
  };
  Parser.parse = function parse(xml, broker, options) {
    var parser = new Parser(broker);
    return parser.parse(xml, options);
  };
  _proto9.parse = function parse(xml, options) {
    var _this = this;
    this.skipNormalisation = options && options.skipNormalisation ? options.skipNormalisation : false;
    return new Promise(function (resolve, reject) {
      try {
        var parser = _sax["default"].parser(true);
        parser.onerror = function (e) {
          _YoLog.YoLog.e("Failed to parse document: " + e);
          resolve(null);
        };
        parser.ontext = _this.onText;
        parser.onopentag = _this.onOpenTag;
        parser.onclosetag = _this.onCloseTag;
        parser.oncdata = _this.onCdata;
        parser.write(xml).close();
        var payload = null;
        if (_this.isVmap) {
          if (!_this.isValidVAST) {
            _YoLog.YoLog.e("Failed to parse document.  VAST not valid");
            resolve(null);
          }
        } else {
          _YoLog.YoLog.e("Failed to parse document.  VMAP not found");
          resolve(null);
        }
        logParsingSummary(_this);
        payload = new _AnalyticPayload.AnalyticPayload(_this, xml.toString());
        resolve(payload);
      } catch (err) {
        reject(err);
      }
    });
  };
  _proto9.parseMapForOnEndTracking = function parseMapForOnEndTracking(map) {
    var characters = this.characters.trim();
    var report = map.get(this.creativeData.trackingEvent);
    if (!report) {
      if (this.creativeData.trackingEvent.indexOf("progress") !== -1) {
        report = new _TrackingReport.TrackingReport("progress", [characters]);
      } else {
        report = new _TrackingReport.TrackingReport(this.creativeData.trackingEvent, [characters]);
      }
      map.set(this.creativeData.trackingEvent, report);
    } else {
      report.addTrackingUrl(characters);
    }
  };
  _proto9.pop = function pop(adExtension, addAsChild) {
    var stack = [];
    if (adExtension) {
      stack = this.advertData.extensionStack;
    } else {
      stack = this.advertData.currentCreativeType === CreativeType.COMPANION ? this.creativeData.companionExtensionStack : this.creativeData.extensionStack;
    }
    var node = stack.pop();
    if (addAsChild) {
      stack[stack.length - 1].addChild(node);
    } else {
      if (adExtension) {
        this.advertData.extensions = node;
      } else {
        if (this.advertData.currentCreativeType === CreativeType.COMPANION) {
          this.creativeData.companionExtensions = node;
        } else {
          this.creativeData.extensions = node;
        }
      }
    }
  };
  _proto9.populateCompanionProperty = function populateCompanionProperty(attributes, name) {
    this.populateCreativeProperty(attributes, name);
  };
  _proto9.populateCompanionPropertyList = function populateCompanionPropertyList(attributes) {
    this.populateCompanionProperty(attributes, "id");
    this.populateCompanionProperty(attributes, "width");
    this.populateCompanionProperty(attributes, "height");
    this.populateCompanionProperty(attributes, "assetWidth");
    this.populateCompanionProperty(attributes, "assetHeight");
    this.populateCompanionProperty(attributes, "expandedWidth");
    this.populateCompanionProperty(attributes, "expandedHeight");
    this.populateCompanionProperty(attributes, "apiFramework");
    this.populateCompanionProperty(attributes, "adSlotId");
    this.populateCompanionProperty(attributes, "pxratio");
    this.populateCompanionProperty(attributes, "renderingMode");
  };
  _proto9.populateCreativeProperty = function populateCreativeProperty(attributes, name) {
    var attr = attributes[name];
    if (!(0, _StringUtils.isNullOrEmpty)(attr)) {
      this.creativeData.properties.push(new _VASTProperty.VASTProperty(name, attr));
    }
  };
  _proto9.populateIconProperty = function populateIconProperty(attributes, name) {
    var attr = attributes[name];
    if (!(0, _StringUtils.isNullOrEmpty)(attr)) {
      this.iconData.properties.push(new _VASTProperty.VASTProperty(name, attr));
    }
  };
  _proto9.populateIconPropertyList = function populateIconPropertyList(attributes) {
    this.populateIconProperty(attributes, "width");
    this.populateIconProperty(attributes, "height");
    this.populateIconProperty(attributes, "program");
    this.populateIconProperty(attributes, "xPosition");
    this.populateIconProperty(attributes, "yPosition");
    this.populateIconProperty(attributes, "offset");
    this.populateIconProperty(attributes, "duration");
    this.populateIconProperty(attributes, "apiFramework");
    this.populateIconProperty(attributes, "pxratio");
  };
  _proto9.populateIconClickFallbackImageProperty = function populateIconClickFallbackImageProperty(attributes, name) {
    var attr = attributes[name];
    if (!(0, _StringUtils.isNullOrEmpty)(attr)) {
      this.iconClickFallbackImageData.properties.push(new _VASTProperty.VASTProperty(name, attr));
    }
  };
  _proto9.populateIconClickFallbackImagePropertyList = function populateIconClickFallbackImagePropertyList(attributes) {
    this.populateIconClickFallbackImageProperty(attributes, "width");
    this.populateIconClickFallbackImageProperty(attributes, "height");
  };
  _proto9.populateInteractiveCreativeProperty = function populateInteractiveCreativeProperty(attributes, name) {
    this.populateCreativeProperty(attributes, name);
  };
  _proto9.populateInteractiveCreativePropertyList = function populateInteractiveCreativePropertyList(attributes) {
    this.populateInteractiveCreativeProperty(attributes, "apiFramework");
    this.populateInteractiveCreativeProperty(attributes, "type");
    var variableDuration = attributes["variableDuration"];
    if (!(0, _StringUtils.isNullOrEmpty)(variableDuration)) {
      this.populateInteractiveCreativeProperty(attributes, "variableDuration");
    } else {
      this.creativeData.properties.push(new _VASTProperty.VASTProperty("variableDuration", "false"));
    }
  };
  _proto9.populateNonLinearProperty = function populateNonLinearProperty(attributes, name) {
    this.populateCreativeProperty(attributes, name);
  };
  _proto9.populateNonLinearPropertyList = function populateNonLinearPropertyList(attributes) {
    this.populateNonLinearProperty(attributes, "id");
    this.populateNonLinearProperty(attributes, "width");
    this.populateNonLinearProperty(attributes, "height");
    this.populateNonLinearProperty(attributes, "expandedWidth");
    this.populateNonLinearProperty(attributes, "expandedHeight");
    this.populateNonLinearProperty(attributes, "scalable");
    this.populateNonLinearProperty(attributes, "maintainAspectRatio");
    this.populateNonLinearProperty(attributes, "apiFramework");
    this.populateNonLinearProperty(attributes, "minSuggestedDuration");
  };
  return Parser;
}();
exports.Parser = Parser;